export default __webpack_public_path__ + "static/media/4.30d5266d.jpg";